import { Component, Input } from '@angular/core';

@Component({
  selector: 'client-setup-progress-bar',
  templateUrl: './setup-progress-bar.component.html',
  styleUrls: ['./setup-progress-bar.component.scss'],
  standalone: false
})
export class SetupProgressBarComponent {
  @Input() progressBarHeader: string = '';
  @Input() progressBarValue: number = 0;
  @Input() showProgress: boolean = true;
}
